<template>
    <v-container fluid class="pa-0">
        <v-card class="mr-3 ml-3 mb-3">
            <v-card-title>
                <v-btn
                    color="green"
                    dark
                    to="/news/null"
                    v-if="$store.getters.user.roleId === 0"
                >
                    <v-icon>mdi-plus</v-icon>
                    Создать новость
                </v-btn>
                <v-spacer />
                <v-text-field
                    v-model="search"
                    hide-details
                    single-line
                    label="Поиск"
                    append-icon="mdi-magnify"
                    style="max-width: 450px; font-weight: 400; margin-top: 0px;"
                ></v-text-field>
            </v-card-title>
            <v-data-table
                :headers="headers"
                :items="news"
                :search="search"
                :loading="loading"
                :items-per-page="10"
                hide-default-footer
                @click:row="updateNew"
                loading-text="Загрузка списка новостей..."
            >
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer
                        :pagination="pagination"
                        :options="options"
                        @update:options="updateOptions"
                        :items-per-page-options="[10, 50, 100, -1]"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText"
                    />
                </template>

                <!-- <template v-slot:item.news_type="{item}">
                    {{ item.news_type === 0 ? 'Новость/статья' : 'Обновление (ченджлог, хистори)' }}
                </template>

                <template v-slot:item.soft_type="{item}">
                    {{ findSoft(item.soft_type) }}
                </template>

                <template v-slot:item.date="{item}">
                    {{ formattedPublicationDate(item.date) }}
                </template>

                <template v-slot:item.create_time="{item}">
                    {{ formattedDate(item.create_time) }}
                </template>

                <template v-slot:item.update_time="{item}">
                    {{ formattedDate(item.update_time) }}
                </template> -->

                <template v-slot:item.actions="{item}">
                    <v-btn
                        icon
                        color="warning"
                        @click.stop="updateNew(item)"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                        icon
                        color="red"
                        @click.stop="deleteNewConfirm(item)"
                    >
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <confirmation-dialog
            ref="confirmation"
            title="Удаление Новости"
            agree-button="Удалить"
            disagree-button="Отмена"
            @agree="deleteNew($event)"
        ></confirmation-dialog>
    </v-container>
</template>

<script>
    import API from "@/axios/api";
    import ConfirmationDialog from "../ConfirmationDialog.vue";

    export default {
        name: "News",
        components: {
            ConfirmationDialog,
        },
        data() {
            return {
                search: '',
                news: [],
                headers: [
                    { text: 'ID', value: 'id' },
                    { text: 'Вид софта', value: 'soft_type' },
                    { text: 'Вид новости', value: 'news_type' },
                    { text: 'Дата публикации', value: 'date', align: 'center' },
                    { text: 'Заголовок', value: 'title' },
                    { text: 'Статистика просмотров', value: 'view_count', align: 'center' },
                    { text: 'Дата создания', value: 'create_time', align: 'center' },
                    { text: 'Дата последнего изменения', value: 'update_time', align: 'center' },
                    { text: 'Изменил', value: 'last_user_name' },
                    { text: 'Действия', value: 'actions', align: 'center', sortable: false }
                ],
                loading: false,
                softTypes: [],
            }
        },
        async activated() {
            this.loading = true;
            // this.news = [];
            this.$store.commit('setCrumbs', [
                {text: 'main', disabled: false, to: '/', exact: true},
                {text: 'news', disabled: false, to: '/news', exact: true}
            ])
            try {
                const response = await API.get('news/public_projects')
                this.softTypes = response.data.data
            } catch (error) {
                console.error(error)
                this.$store.commit('showSnackbar', {
                    color: 'error',
                    text: 'Ошибка при получении списка софтов',
                })
            }
            await this.getNews();
            this.loading = false;
        },
        methods: {
            findSoft(softId) {
                const object = this.softTypes.find(obj => obj.id === softId);
                return object?.name;
            },

            formattedDate(date) {
                const date_ = new Date(date);
                const day = String(date_.getDate()).padStart(2, '0');
                const month = String(date_.getMonth() + 1).padStart(2, '0');
                const year = date_.getFullYear();
                const hours = String(date_.getHours()).padStart(2, '0');
                const minutes = String(date_.getMinutes()).padStart(2, '0');
                return `${day}.${month}.${year} ${hours}:${minutes}`;
            },

            formattedPublicationDate(date) {
                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            },

            updateNew(item) {
                const id = item.id;
                this.$router.push({ name: 'New', params: { id } })
            },

            deleteNewConfirm(new_) {
                this.$refs.confirmation.showDialog(
                    new_.id,
                    `Вы действительно хотите удалить Новость №<span class="highlighted">${new_.id}</span> (<span class="highlighted">${new_.title}</span>)?`
                );
            },

            async deleteNew(itemId) {
                this.loading = true;
                await API.delete(`news/${itemId}/delete`).then((response) => {
                    console.log(response.data);
                    this.$store.commit('showSnackbar', {
                        color: 'success',
                        text: 'Новость удалена',
                    })
                })
                .catch((error) => {
                    console.log(error);
                    this.$store.commit('showSnackbar', {
                    color: 'error',
                    text: 'Новость не удалена',
                    })
                });
                await this.getNews();
                this.loading = false;
            },

            async getNews() {
                try {
                    const response = await API.get('news')
                    let newsArray = response.data.data;
                    newsArray.forEach(obj => {
                        obj.news_type = obj.news_type === 0 ? 'Новость/статья' : 'Обновление (ченджлог, хистори)'
                        obj.soft_type = this.findSoft(obj.soft_type);
                        obj.date = this.formattedPublicationDate(obj.date);
                        obj.create_time = this.formattedDate(obj.create_time);
                        obj.update_time = this.formattedDate(obj.update_time);
                    })
                    this.news = newsArray;
                } catch (error) {
                    console.error(error)
                    this.$store.commit('showSnackbar', {
                        color: 'error',
                        text: 'Ошибка при получении списка новостей',
                    })
                }
            }
        }
    }
</script>

<style scoped>

</style>